import {inject, Injectable} from '@angular/core';
import {UtilityService} from "../../../../services/utility.service";
import {documentDateFields, isDocumentDateKey} from "../configs/document-date-config";
import {DocumentData} from "../types/document-modal.types";
import {ValidationService} from "../../../../services/validation.service";
import {FormGroup} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class DocumentDateService {
  private utilityService: UtilityService = inject(UtilityService);
  private validationService: ValidationService = inject(ValidationService);

  public convertDates(documentData: DocumentData): DocumentData {
    documentDateFields.forEach(field => {
      if (isDocumentDateKey(field)) {
        documentData[field].date = this.utilityService.convertToDate(documentData[field].date);
      }
    });

    return documentData;
  }

  public validDateMessage(documentForm: FormGroup, key: string): string {
    const contract = documentForm.get('contract')?.get('date')?.value;
    const act = documentForm.get('act')?.get('date')?.value;
    const payment = documentForm.get('payment')?.get('date')?.value;
    switch (key) {
      case 'contract':
        return this.validationService.compareDates({
          earlierDate: contract,
          laterDate: act
        }) ? '' : 'Дата договора должна быть раньше даты акта';
      case 'act':
        return this.validationService.compareDates({
          earlierDate: contract,
          laterDate: act
        }) ? '' : 'Дата акта должна быть позже даты договора';
      case 'payment':
        return this.validationService.compareDates({
          earlierDate: contract,
          laterDate: payment
        }) ? '' : 'Дата платежа должна быть позже даты договора';
      default:
        return '';
    }
  }
}
